import ProjectDetailsEditContainer from "internal/programs/migration-acceleration-program/2024/fund-request/components/edit/ProjectDetailsEditContainer/ProjectDetailsEditContainer";

export default ProjectDetailsEditContainer;
